import restorePreview from "./restore-preview";

export default () => {
  restorePreview();
};
